import * as Framer from "framer";
import { ResolveLinks, useSiteRefs } from "framer";
import * as React from "react";
import { createPortal } from "react-dom";
import * as ReactDOM from "react-dom/client";
import LayoutNavBarFooter from "https://framerusercontent.com/modules/jiP0LuLL8oABXJUJTeFp/AQoi6adhcdq6mTYNYd8a/fhv6dLWsC.js";

const routes = {
  augiA20Il: {
    elements: {
      BpdroLjj9: "heading-1",
      bS1G9Sni_: "features",
      BvppAfnk5: "contact",
      EPNLgrdSW: "intro",
      IBUZYUiP7: "testimonials",
      ICQeMyiyD: "pricing",
      L9zgnjSzF: "contact-mobile",
      mhtVpKSfK: "navbar-bg",
      nqftuNsKy: "heading",
      w0Wr2L5KY: "faq",
      wJCoP1HKt: "hero",
      YBiNeOYcb: "values",
      Z1Onzhrf5: "form-1",
      zvJ1fLqy5: "form",
    },
    page: Framer.lazy(
      () =>
        import("https://framerusercontent.com/modules/8jDjNMaivyx8227HBWQo/0Bqsp8s7k9RyfX5sdUCV/augiA20Il.js"),
    ),
    path: "/",
  },
  ezYMDBuLi: {
    elements: { fvp2g9fo9: "navbar-bg" },
    page: Framer.lazy(
      () =>
        import("https://framerusercontent.com/modules/oF37anmQuLXOZT9U1C9G/V4k739G1btAgm2REGig2/ezYMDBuLi.js"),
    ),
    path: "/404",
  },
  MjRdY2E_Y: {
    elements: {},
    page: Framer.lazy(
      () =>
        import("https://framerusercontent.com/modules/JZ7S4CIn4p6SpZaPSt1T/LQfSjq0CINY10jRheLu5/MjRdY2E_Y.js"),
    ),
    path: "/page",
  },
};

const locales = [{ code: "en", id: "default", name: "English", slug: "" }];
const collectionUtils = {};
const framerSiteId =
  "f34538045882bd5e83eb53bfa45ca725b89e4e18f57d2b53ed35bf4b93179c8b";
function Template({ routeId, children, style, ...rest }) {
  const props1 = {
    Z7VMRRT6h: {
      href: { hash: ":mhtVpKSfK", webPageId: "augiA20Il" },
      refKey: true,
    },
  };
  const props2 = {
    ...props1,
    Z7VMRRT6h: {
      href: { hash: ":fvp2g9fo9", webPageId: "ezYMDBuLi" },
      refKey: true,
    },
  };
  const props3 = { ...props1, Z7VMRRT6h: undefined };
  const siteRef = useSiteRefs();
  const templateProps = {
    augiA20Il: props1,
    ezYMDBuLi: props2,
    MjRdY2E_Y: props3,
  };
  const props = templateProps[routeId] ?? {};
  switch (routeId) {
    case "augiA20Il":
    case "ezYMDBuLi":
    case "MjRdY2E_Y":
      return React.createElement(
        ResolveLinks,
        { links: [props["Z7VMRRT6h"]] },
        (resolvedLinks) =>
          React.createElement(
            LayoutNavBarFooter,
            {
              ...props,
              key: "LayoutNavBarFooter",
              routeId,
              style,
              Z7VMRRT6h: siteRef(resolvedLinks[0]),
            },
            children(true),
          ),
      );
    default: {
      return children(false);
    }
  }
}
export function getLayoutTemplateBreakpoints(routeId) {
  switch (routeId) {
    case "augiA20Il":
    case "ezYMDBuLi":
    case "MjRdY2E_Y":
      return [
        { hash: "1v8948n", mediaQuery: "(min-width: 1440px)" },
        {
          hash: "1l1lbps",
          mediaQuery: "(min-width: 810px) and (max-width: 1439.98px)",
        },
        { hash: "wcqt3f", mediaQuery: "(max-width: 809.98px)" },
      ];
    default: {
      return undefined;
    }
  }
}

export async function getPageRoot({ routeId, pathVariables, localeId }) {
  const rootPreload = routes[routeId].page.preload();

  const content = React.createElement(Framer.PageRoot, {
    isWebsite: true,
    routeId,
    pathVariables,
    routes,
    collectionUtils,
    framerSiteId,
    notFoundPage: Framer.lazy(
      () =>
        import("https://framerusercontent.com/modules/oF37anmQuLXOZT9U1C9G/V4k739G1btAgm2REGig2/ezYMDBuLi.js"),
    ),
    isReducedMotion: undefined,
    localeId,
    locales,
    preserveQueryParams: undefined,
    siteCanonicalURL: "https://collabyn.com",
    EditorBar:
      false ? (() => {
            const isBot =
              /bot|-google|google-|yandex|ia_archiver|crawl|spider/iu.test(
                navigator.userAgent,
              );
            if (isBot) {
              console.log(
                "[Framer Editor Bar] Unavailable because navigator is bot",
              );
              return;
            }

            return Framer.lazy(async () => {
              const dependencies = {
                __version: 2,
                framer: {
                  useCurrentRoute: Framer.useCurrentRoute,
                  useLocaleInfo: Framer.useLocaleInfo,
                  useRouter: Framer.useRouter,
                },
                react: {
                  createElement: React.createElement,
                  Fragment: React.Fragment,
                  memo: React.memo,
                  useCallback: React.useCallback,
                  useEffect: React.useEffect,
                  useRef: React.useRef,
                  useState: React.useState,
                },
                "react-dom": { createPortal },
              };

              window.__framer_editorBarDependencies = dependencies;

              const { createEditorBar } =
                await import("https://framer.com/edit/init.mjs");
              return {
                default: createEditorBar(),
              };
            });
          })()
        : undefined,
    LayoutTemplate: Template,
  });

  const contentWithFeaturesContext = React.createElement(
    Framer.LibraryFeaturesProvider,
    {
      children: content,
      value: {
        cssCollector: true,
        editorBarDisableFrameAncestorsSecurity: false,
        motionDivToDiv: false,
        motionDivToDivBackgroundImage: true,
        pauseOffscreen: true,
        synchronousNavigationOnDesktop: false,
        yieldOnTap: false,
      },
    },
  );

  const contentWithGracefullyDegradingErrorBoundary = React.createElement(
    Framer.GracefullyDegradingErrorBoundary,
    {
      children: contentWithFeaturesContext,
    },
  );

  const page = React.createElement(Framer.PageEffectsProvider, {
    children: contentWithGracefullyDegradingErrorBoundary,
    value: { routes: {} },
  });

  // We don't want the initial render to immediately have to suspend.
  await rootPreload;
  return page;
}

const isBrowser = typeof document !== "undefined";
if (isBrowser) {
  window.__framer_importFromPackage =
    (packageAndFilename, exportIdentifier) => () => {
      return React.createElement(Framer.ErrorPlaceholder, {
        error:
          'Package component not supported: "' +
          exportIdentifier +
          '" in "' +
          packageAndFilename +
          '"',
      });
    };

  // A lot of libraries assume process.env.NODE_ENV is present in runtime/buildtime, so we are polyfilling it
  window.process = {
    ...window.process,
    env: {
      ...(window.process ? window.process.env : undefined),
      NODE_ENV: "production",
    },
  };

  window.__framer_events = window.__framer_events || [];

  // Fallback support for stack gaps
  Framer.installFlexboxGapWorkaroundIfNeeded();

  const container = document.getElementById("main");
  // We know that #main is parsed before this script, so we don't need to wait for DOMContentLoaded or similar events.
  if ("framerHydrateV2" in container.dataset) main(true, container);
  else main(false, container);
}

function track() {
  if (!isBrowser) return;
  window.__framer_events.push(arguments);
}

async function main(shouldHydrate, container) {
  function handleError(error, errorInfo, recoverable = true) {
    if (error.caught || window.__framer_hadFatalError) return; // we already logged it

    const componentStack = errorInfo?.componentStack;
    if (recoverable) {
      console.warn(
        "Recoverable error has happened. Please check any custom code or code overrides to fix server/client mismatches:\n",
        error,
        componentStack,
      );
      // we only want to collect 1%, because this can be quite noisy (floods the data pipeline)
      if (Math.random() > 0.01) return;
    } else {
      console.error(
        "Fatal crash has happened. If you are the author of this website, please report this issue to the Framer team via https://www.framer.community/:\n",
        error,
        componentStack,
      );
    }
    track(
      recoverable
        ? "published_site_load_recoverable_error"
        : "published_site_load_error",
      {
        message: String(error),
        componentStack, // componentStack is more useful
        stack: componentStack
          ? undefined
          : error instanceof Error && typeof error.stack === "string"
            ? error.stack
            : null,
      },
    );
  }

  try {
    let routeId, localeId, pathVariables, breakpoints;
    if (shouldHydrate) {
      const routeData = JSON.parse(container.dataset["framerHydrateV2"]);
      routeId = routeData.routeId;
      localeId = routeData.localeId;
      pathVariables = routeData.pathVariables;
      breakpoints = routeData.breakpoints;

      routeId = Framer.patchRoutesForABTesting(routes, routeId); // Prioritize optimized route id to avoid flickering in browsers not supporting the server-timing header (Safari older than 16.4)
    } else {
      Framer.patchRoutesForABTesting(routes, undefined); // This must happen before inferInitialRouteFromPath

      const routeData = Framer.inferInitialRouteFromPath(
        routes,
        decodeURIComponent(location.pathname),
        true,
        locales,
      );
      routeId = routeData.routeId;
      localeId = routeData.localeId;
      pathVariables = routeData.pathVariables;
    }

    const pagePromise = getPageRoot({ routeId, localeId, pathVariables });

    if (typeof window !== "undefined") {
      void (async () => {
        const route = routes[routeId];

        const defaultLocaleId = "default";
        const framerLocale = locales.find(({ id }) =>
          !localeId ? id === defaultLocaleId : id === localeId,
        ).code;

        let collectionItemId = null;
        if (route?.collectionId && collectionUtils) {
          const utils = await collectionUtils[route.collectionId]?.();
          const [slug] = Object.values(pathVariables);
          if (utils && typeof slug === "string") {
            collectionItemId =
              (await utils.getRecordIdBySlug(
                slug,
                framerLocale || undefined,
              )) ?? null;
          }
        }

        const resolvedDateTimeOptions = Intl.DateTimeFormat().resolvedOptions();
        const timezone = resolvedDateTimeOptions.timeZone;
        const locale = resolvedDateTimeOptions.locale;

        // wait for the page to be activated before sending the pageview event
        // https://developer.chrome.com/docs/web-platform/prerender-pages#impact-on-analytics
        await new Promise((resolve) => {
          if (document.prerendering) {
            document.addEventListener("prerenderingchange", resolve, {
              once: true,
            });
          } else {
            resolve();
          }
        });

        window.__framer_events.push([
          "published_site_pageview",
          {
            framerSiteId: framerSiteId ?? null,
            version: 2,
            routePath: route?.path || "/",
            collectionItemId,
            framerLocale: framerLocale || null,
            webPageId: route?.abTestingVariantId ?? routeId,
            abTestId: route?.abTestId,
            referrer: document.referrer || null,
            url: window.location.href,
            hostname: window.location.hostname || null,
            pathname: window.location.pathname || null,
            hash: window.location.hash || null,
            search: window.location.search || null,
            timezone,
            locale,
          },
          "eager",
        ]);

        // Yield to avoid blocking the main thread with the user code
        await Framer.yieldToMain({
          priority: "background",
          ensureContinueBeforeUnload: true,
          continueAfter: "paint",
        });

        document.dispatchEvent(
          new CustomEvent("framer:pageview", {
            detail: { framerLocale: framerLocale || null },
          }),
        );
      })();
    }

    const page = await pagePromise;
    if (shouldHydrate) {
      Framer.withPerformanceMarks("framer-rewrite-breakpoints", () => {
        Framer.removeHiddenBreakpointLayersV2(breakpoints);
        window.__framer_onRewriteBreakpoints?.(breakpoints);
      });

      const startTransition = React.startTransition;
      startTransition(() => {
        Framer.markHydrationStart();
        if (true) Framer.turnOffReactEventHandling();
        ReactDOM.hydrateRoot(container, page, {
          onRecoverableError: handleError,
        });
      });
    } else {
      ReactDOM.createRoot(container, {
        onRecoverableError: handleError,
      }).render(page);
    }
  } catch (error) {
    handleError(error, undefined, false);
    throw error;
  }
}
